import { render, staticRenderFns } from "./translation-manager.vue?vue&type=template&id=065d5d0d&scoped=true"
import script from "./translation-manager.vue?vue&type=script&lang=js"
export * from "./translation-manager.vue?vue&type=script&lang=js"
import style0 from "./translation-manager.vue?vue&type=style&index=0&id=065d5d0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d5d0d",
  null
  
)

export default component.exports